import { translate } from 'hooks/useTranslate';
import { axiosV2 } from 'interceptors/axios';
import { downloadBlob } from 'utils/downloadBlob';

type DownloadPartnersTablePdfProps = {
  fileName: string;
  societyId: string;
  categoryId?: string;
};
export const downloadPartnersTablePdf = async ({
  fileName,
  societyId,
  categoryId,
}: DownloadPartnersTablePdfProps) => {
  const { data } = await axiosV2.get<Blob>('/societies/partners-table-pdf', {
    params: { societyId, categoryId },
    responseType: 'blob',
  });
  downloadBlob(data, `${fileName || translate('Partners')}.pdf`);
};
